import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';
import {RouterLink} from "@angular/router";
import {NotificationsComponent} from "../notifications/notifications.component";
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  declarations: [
    HeaderComponent
  ],
    imports: [
        CommonModule,
        RouterLink,
        NotificationsComponent,
        TranslateModule
    ],
  exports: [
    HeaderComponent
  ]
})
export class HeaderModule { }
